import gql from 'graphql-tag';

export const createAsset = gql`mutation($filename: String!, $imageData: String!, $assetFolder: Int!){
    createAsset(
        filename: $filename,
        input: {
            data: $imageData,
            filename: $filename,
            parentId: $assetFolder
        },
        parentId: $assetFolder,
        type: "image"
    ) {
        success
        message
        assetData {
            id
            fullpath
        }
    }
}`;
